import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { LangProvider } from "./lib/i18n";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Quotations from "./pages/Quotations";
import QuoteWorkspace from "./pages/QuoteWorkspace";
import Customers from "./pages/Customers";
import Catalog from "./pages/Catalog";
import Technicians from "./pages/Technicians";
import TaxRules from "./pages/TaxRules";
import Settings from "./pages/Settings";
import UsersPage from "./pages/Users";
import Audit from "./pages/Audit";
import Schedule from "./pages/Schedule";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center text-sm text-neutral-500">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Home() {
  const { can } = useAuth();
  return can("dashboard") ? <Dashboard /> : <Customers />;
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Home />} />
              <Route path="quotations" element={<Quotations />} />
              <Route path="quotations/:id" element={<QuoteWorkspace />} />
              <Route path="customers" element={<Customers />} />
              <Route path="catalog" element={<Catalog />} />
              <Route path="technicians" element={<Technicians />} />
              <Route path="tax" element={<TaxRules />} />
              <Route path="settings" element={<Settings />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="audit" element={<Audit />} />
              <Route path="schedule" element={<Schedule />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="bottom-right" />
      </AuthProvider>
    </LangProvider>
  );
}
